export default "__VITE_ASSET__BKhAafg4__"